import { Module } from 'vuex-smart-module';
import CartSharedActions from './actions';
import CartSharedGetters from './getters';
import CartSharedMutations from './mutations';
import CartSharedState from './state';

export default new Module({
  state: CartSharedState,
  mutations: CartSharedMutations,
  actions: CartSharedActions,
  getters: CartSharedGetters,
});
